import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SignIn } from "pages/UserAuth/SignIn";
import { ForgetUsername } from "pages/UserAuth/ForgetUsername";
import { ForgetPassword } from "pages/UserAuth/ForgetPassword";
import { ResetPassword } from "pages/UserAuth/ResetPassword";
import { ProtectedRoutes } from "auth/ProtectedRoutes";
import { PrivateRoutes } from "pages/Dashboard/Dashboard";
import { ErrorPage } from "pages/ErrorPage/ErrorPage";


export const RoutesComponent = () => {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/ForgetUsername" element={<ForgetUsername />} />
      <Route path="/ForgetPassword" element={<ForgetPassword />} />
      <Route path="/ResetPassword/:passwordResetToken" element={<ResetPassword />} />
      <Route element={<ProtectedRoutes />}>
        <Route path=":id" element={<PrivateRoutes />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
